<template>
  <div id="app">
    <Header />
    <main class="main-content">
      <keep-alive>
        <router-view />
      </keep-alive>
    </main>
    <Footer />
    <!-- 回到顶部 -->
    <transition name="fade">
      <button
        v-show="showBackTop"
        class="back-to-top"
        @click="scrollToTop"
        aria-label="回到顶部"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="18 15 12 9 6 15"></polyline>
        </svg>
      </button>
    </transition>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      showBackTop: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showBackTop = window.pageYOffset > 400
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss">
.main-content {
  min-height: calc(100vh - #{$header-height} - 300px);
  padding-top: $header-height;

  @include mobile-only {
    padding-top: $header-height-mobile;
  }
}

.back-to-top {
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 48px;
  height: 48px;
  border-radius: $radius-full;
  background-color: $color-primary;
  color: $color-text-white;
  @include flex-center;
  box-shadow: $shadow-md;
  z-index: $z-index-header;
  transition: all $transition-base;

  &:hover {
    background-color: $color-primary-dark;
    transform: translateY(-3px);
    box-shadow: $shadow-lg;
  }

  @include mobile-only {
    bottom: 24px;
    right: 24px;
    width: 40px;
    height: 40px;
  }
}
</style>
